import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'
import { Loading } from '@/components/ui/loading'
import { TutorialGuard } from '@/features/onboarding/components/TutorialGuard'

export function PrivateRoute() {
  const { user, loading } = useAuthStore()

  if (loading) {
    return <Loading />
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return (
    <TutorialGuard>
      <Outlet />
    </TutorialGuard>
  )
} 